import { getClosestProductTrackingContainerValue } from "@shared/Utils/analytics-utils";
import { dispatchMbbAddProduct, parseMbbBundle } from "../ShoppingCart/Helpers/mbb-add-product";

const initMbbOrderButtons = () => {
  const orderButtons = document.querySelectorAll<HTMLElement>('[name="btn-mbb-order"][data-mbb-bundle]');
  for (const button of orderButtons) {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      dispatchMbbAddProduct(
        parseMbbBundle(button.dataset.mbbBundle as string),
        button,
        getClosestProductTrackingContainerValue(button) ?? "",
      );
    });
  }
};

initMbbOrderButtons();
